var React = require('react');

function SidebarIconSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M36.1,32.7c0.2-0.2,0.2-0.6,0-0.9l-7.1-7.3c-0.2-0.2-0.3-0.7-0.2-1c0,0,1.3-3.5,1.3-5.8\n\tC30.2,10.1,24.2,4,16.9,4S3.7,10.1,3.7,17.7c0,7.6,5.9,13.7,13.2,13.7c3.1,0,7.8-2.7,7.8-2.7c0.3-0.2,0.7-0.1,0.9,0.1l6.7,6.9\n\tc0.2,0.2,0.6,0.2,0.9,0L36.1,32.7z M9.1,17.7c0-4.5,3.5-8.2,7.8-8.2s7.8,3.7,7.8,8.2s-3.5,8.2-7.8,8.2C12.6,25.9,9.1,22.2,9.1,17.7\n\tz"}));
}

SidebarIconSearch.defaultProps = {"id":"search","viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = SidebarIconSearch;

SidebarIconSearch.default = SidebarIconSearch;
